module.exports = __webpack_public_path__ + "img/Banner-Construction-dwnszd.6aa1aea7.jpg";